import React from 'react';
import PropTypes from 'prop-types';
import { addonsQuantityFormatter } from '../../addons';
import {
  OrderPricing,
  Price,
  ListItemsContainer,
  StyledLiContainer,
  StrikePrice,
  QuantityLabel,
  ProductName,
} from './SummaryItem.styles';

export const StyledLi = ({
  key,
  product_name,
  quantity,
  product_type,
  price,
  discounted_price,
  period,
  pricePerPeriod,
  sku,
}) => {
  return (
    <ListItemsContainer>
      <StyledLiContainer key={key}>
        <ProductName>
          {product_name + ': '}
          <QuantityLabel>
            {addonsQuantityFormatter(quantity, product_type, sku)}
          </QuantityLabel>
        </ProductName>
        <OrderPricing>
          <StrikePrice small>{price}</StrikePrice>
          <Price small>{discounted_price}/ea.</Price>
          {pricePerPeriod && (
            <Price>
              {pricePerPeriod}/{period}
            </Price>
          )}
        </OrderPricing>
      </StyledLiContainer>
    </ListItemsContainer>
  );
};

StyledLi.displayName = 'StyledLi';
StyledLi.propTypes = {
  key: PropTypes.string,
  product_name: PropTypes.string,
  quantity: PropTypes.string,
  product_type: PropTypes.string,
  price: PropTypes.string,
  discounted_price: PropTypes.string,
  period: PropTypes.string,
  pricePerPeriod: PropTypes.string,
};
